module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "status"
  }, [_c('ul', _vm._l((_vm.status), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        'active': index + 1 <= _vm.step, 'current': index + 1 === _vm.step
      }
    }, [_c('span', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(item.join('<br/>'))
      }
    })])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e327297"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/components/StepStatus.vue
// module id = 843
// module chunks = 1